export default __webpack_public_path__ + "static/media/parameters.0cb12eb1.svg";